import Favorite from "../../lib/favorite/favorite";

$(window).on('load resize', function () {
  var winW = $(window).width();
  var devW = 960;
  var contents_w = $(".info_area").width();
  if (winW <= devW) {
    $('.prev').click(function () {
      $('.bookmark_main').animate({
        scrollLeft: $('.bookmark_main').scrollLeft() - contents_w //〇〇px左にスクロールする
      }, 300); //スクロールにかかる時間
    });
    $('.next').click(function () {
      $('.bookmark_main').animate({
        scrollLeft: $('.bookmark_main').scrollLeft() + contents_w //〇〇px右にスクロールする
      }, 300); //スクロールにかかる時間
    });

  } else {
    $('.prev').click(function () {
      $('.bookmark_main').animate({
        scrollLeft: $('.bookmark_main').scrollLeft() - contents_w //〇〇px左にスクロールする
      }, 300); //スクロールにかかる時間
    });
    $('.next').click(function () {
      $('.bookmark_main').animate({
        scrollLeft: $('.bookmark_main').scrollLeft() + contents_w //〇〇px右にスクロールする
      }, 300); //スクロールにかかる時間
    });

  }
});


$(function () {

  var h = 0;
  $(".info_area .name,.names_area .name").each(function () {
    if ($(this).outerHeight() > h) {
      h = $(this).outerHeight();
    }
  });
  $(".names_area .name").css("height", h + "px");
  $(".info_area .name").css("height", h + "px");

  var h2 = 0;
  $(".info_area .add,.names_area .add").each(function () {
    if ($(this).outerHeight() > h2) {
      h2 = $(this).outerHeight();
    }
  });
  $(".names_area .add").css("height", h2 + "px");
  $(".info_area .add").css("height", h2 + "px");

  var h3 = 0;
  $(".info_area .sta,.names_area .sta").each(function () {
    if ($(this).outerHeight() > h3) {
      h3 = $(this).outerHeight();
    }
  });
  $(".names_area .sta").css("height", h3 + "px");
  $(".info_area .sta").css("height", h3 + "px");

});
$(function () {

  var h = 0;
  $(".info_area .hum,.names_area .hum").each(function () {
    if ($(this).outerHeight() > h) {
      h = $(this).outerHeight();
    }
  });
  $(".names_area .hum").css("height", h + "px");
  $(".info_area .hum").css("height", h + "px");

  var h1 = 0;
  $(".info_area .cost,.names_area .cost").each(function () {
    if ($(this).outerHeight() > h1) {
      h1 = $(this).outerHeight();
    }
  });
  $(".names_area .cost").css("height", h1 + "px");
  $(".info_area .cost").css("height", h1 + "px");

  var h2 = 0;
  $(".info_area .room,.names_area .room").each(function () {
    if ($(this).outerHeight() > h2) {
      h2 = $(this).outerHeight();
    }
  });
  $(".names_area .room").css("height", h2 + "px");
  $(".info_area .room").css("height", h2 + "px");


  var h3 = 0;
  $(".info_area .tel,.names_area .tel").each(function () {
    if ($(this).outerHeight() > h3) {
      h3 = $(this).outerHeight();
    }
  });
  $(".names_area .tel").css("height", h3 + "px");
  $(".info_area .tel").css("height", h3 + "px");


  var h4 = 0;
  $(".info_area .rou,.names_area .rou").each(function () {
    if ($(this).outerHeight() > h4) {
      h4 = $(this).outerHeight();
    }
  });
  $(".names_area .rou").css("height", h4 + "px");
  $(".info_area .rou").css("height", h4 + "px");


  var h5 = 0;
  $(".info_area .recep,.names_area .recep").each(function () {
    if ($(this).outerHeight() > h5) {
      h5 = $(this).outerHeight();
    }
  });
  $(".names_area .recep").css("height", h5 + "px");
  $(".info_area .recep").css("height", h5 + "px");


  var h6 = 0;
  $(".info_area .camp,.names_area .camp").each(function () {
    if ($(this).outerHeight() > h6) {
      h6 = $(this).outerHeight();
    }
  });
  $(".names_area .camp").css("height", h6 + "px");
  $(".info_area .camp").css("height", h6 + "px");


  var h7 = 0;
  $(".info_area .recom,.names_area .recom").each(function () {
    if ($(this).outerHeight() > h7) {
      h7 = $(this).outerHeight();
    }
  });
  $(".names_area .recom").css("height", h7 + "px");
  $(".info_area .recom").css("height", h7 + "px");


  var h8 = 0;
  $(".info_area .cont,.names_area .cont").each(function () {
    if ($(this).outerHeight() > h8) {
      h8 = $(this).outerHeight();
    }
  });
  $(".names_area .cont").css("height", h8 + "px");
  $(".info_area .cont").css("height", h8 + "px");


  var h9 = 0;
  $(".info_area .all_cont,.names_area .all_cont").each(function () {
    if ($(this).outerHeight() > h9) {
      h9 = $(this).outerHeight();
    }
  });
  $(".names_area .all_cont").css("height", h9 + "px");
  $(".info_area .all_cont").css("height", h9 + "px");

});


$(function () {
  var contents = $(".info_area").length;
  var contents_w = $(".info_area").width();

  var wid = contents * contents_w + 160

  $(".book_list").css("width", wid + "px");
});


$('.info_area .close').on('click', function () {
  // 物件を非表示かつ、送信データから除外
  $(this).parent().hide().find('input').prop('disabled', true);
});

$('[data-button-redisplay]').on('click', function () {
  // 非表示の物件を再表示かつ、送信データとして復元
  $('.info_area').show().find('input').prop('disabled', false);
});


//ブックマーク一覧をドラッグ&ドロップでスライドできるようにする
const dragOfficeList = () => {
  const container = document.querySelector('[data-drag-office-list]');

  // ドラッグ中かどうかのフラグ
  let isDragging = false;

  // ドラッグを開始した時のマウスのX座標
  let startX;

  // ドラッグを開始した時のコンテナのスクロール位置
  let startScrollPosition;

  // マウスボタンが押された時のイベントリスナー
  container.addEventListener('mousedown', (e) => {
    // ドラッグ中フラグをtrueに設定
    isDragging = true;
    // マウスのX座標を記録
    startX = e.pageX;
    // 現在のコンテナのスクロール位置を記録
    startScrollPosition = container.scrollLeft;
    // ドラッグ中のカーソルスタイルを変更
    container.style.cursor = 'grabbing';
  });

  // マウスが移動している時
  container.addEventListener('mousemove', (e) => {
    // ドラッグ中でなければ、処理を終了
    if (!isDragging) return;

    // 現在のマウスのX座標を取得
    const x = e.pageX;
    // ドラッグ開始位置と現在位置の差分を計算
    const deltaX = startX - x;
    // コンテナのスクロール位置をドラッグ開始時の位置に差分を加えて更新
    container.scrollLeft = startScrollPosition + deltaX;
  });

  // マウスボタンが離された時
  container.addEventListener('mouseup', () => {
    // ドラッグ中フラグをfalseに設定
    isDragging = false;
    // ドラッグが終了した後のカーソルスタイルを変更
    container.style.cursor = 'grab';
  });

  // マウスがコンテナから離れた時
  container.addEventListener('mouseleave', () => {
    // ドラッグ中フラグをfalseに設定
    isDragging = false;
    // ドラッグが終了したまたはマウスがコンテナから離れた時のカーソルスタイルを変更
    container.style.cursor = 'grab';
  });
}

dragOfficeList();

(function () {
  const bookmarkRemoveBtns = document.querySelectorAll('[data-favoriteOfficeId]');

  // 全てのお気に入り解除ボタンにクリックイベントを追加する
  bookmarkRemoveBtns.forEach((btn) => {
    btn.addEventListener('click', async function () {
      // お気に入り削除リクエスト
      const response = await Favorite.remove([btn.dataset.favoriteofficeid]);

      // 処理成功
      if (response.data.status) {
        // 物件を表示しないようにする
        btn.closest(`[data-bookmarkedOffice]`).remove();

        //お気に入り数の表示を更新
        const bookmarkCountField = document.querySelector('[data-favorite-offices-count]');
        const bookmarkCount = parseInt(bookmarkCountField.textContent)
        const newBookmarkCount = bookmarkCount - 1
        bookmarkCountField.textContent = newBookmarkCount

      }
      // 処理失敗
      else {
        alert('お気に入りを解除できませんでした');
      }
    })
  })
})();
